module.exports = __webpack_public_path__ + "img/sy1.6e9bdd83.png";